import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  videoStreamChannels: [],
  video_Stream_Status: false,
  videoStreamingStartedPopup: false,
  startedChannelName: "",
  videoStreamAvsChannelList: [],
  currentChannel: {},
  liveChannelsList: [],
  IPCameraVideoStreamingStatus: false,
  IpCameraActiveCount: 0,
  currentLiveChannel: {},
  recording: [],
  errorMessage: "",
  openStreamCamera: false,
  dataForOdk: {},
  IPCameraAngles: [
    {
      id: 1,
      angleName: "WideAngle L",
      allocated: false,
    },
    {
      id: 2,
      angleName: "WideAngle R",
      allocated: false,
    },
    {
      id: 3,
      angleName: "Tight Angle",
      allocated: false,
    },
    {
      id: 4,
      angleName: "Other Angle",
      allocated: false,
    },
    {
      id: 5,
      angleName: "EndZone L",
      allocated: false,
    },
    {
      id: 6,
      angleName: "EndZone R",
      allocated: false,
    },
  ],
};

export const VideoStreamingReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.SET_CAMERA_ANGLE:
      return {
        ...state,
        IPCameraAngles: payload,
      };
    case ActionTypes.SET_ODK_DATA:
      return {
        ...state,
        dataForOdk: payload,
      };
    case ActionTypes.OPEN_STREAM_CAMERA:
      return {
        ...state,
        openStreamCamera: payload,
      };
    case ActionTypes.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: payload,
      };
    case ActionTypes.SET_RECORDING:
      return {
        ...state,
        recording: [...state.recording, ...payload],
      };
    case ActionTypes.RENAME_RECORDING:
      return {
        ...state,
        recording: payload,
      };
    case ActionTypes.VIDEO_STREAM_STATUS:
      return {
        ...state,
        video_Stream_Status: payload,
      };

    case ActionTypes.SET_VIDEO_STREAM_CHANNEL_LIST:
      return {
        ...state,
        videoStreamChannels: payload,
      };

    case ActionTypes.START_STREAMING:
      return {
        ...state,
        videoStreamChannels: state.videoStreamChannels?.map((channel) =>
          payload?.includes(channel?.channelId)
            ? { ...channel, state: "running" }
            : channel
        ),
      };

    case ActionTypes.STOP_STREAMING:
      return {
        ...state,
        videoStreamChannels: state.videoStreamChannels?.map((channel) =>
          payload?.includes(channel?.channelId)
            ? { ...channel, state: "stopped" }
            : channel
        ),
      };

    case ActionTypes.VIDEO_STREAMING_STARTED_POPUP:
      return {
        ...state,
        videoStreamingStartedPopup: payload,
      };

    case ActionTypes.SET_LATEST_STARTED_CHANNEL_NAME:
      return {
        ...state,
        startedChannelName: payload,
      };

    case ActionTypes.ADD_AVS_CHANNEL_DETAILS: {
      if (payload.isAssigned) {
        return {
          ...state,
          videoStreamAvsChannelList: [
            ...state.videoStreamAvsChannelList,
            payload,
          ],
        };
      } else {
        return {
          ...state,
          videoStreamAvsChannelList: [
            ...state.videoStreamAvsChannelList.filter((ele) => {
              return ele.id !== payload.id;
            }),
          ],
        };
      }
    }

    case ActionTypes.SET_ALL_AVS_CHANNEL_LIST:
      return {
        ...state,
        videoStreamAvsChannelList: payload,
      };

    case ActionTypes.SET_CURRENT_CHANNEL_INFORMATION:
      return {
        ...state,
        currentChannel: payload,
      };

    case ActionTypes.UPDATE_CHANNEL_STATUS:
      return {
        ...state,
        videoStreamAvsChannelList: state.videoStreamAvsChannelList.map(
          (channel) =>
            channel?.channelName === payload?.currentChannel?.channelName
              ? { ...channel, assigned: payload?.channelStatus }
              : channel
        ),
      };

    case ActionTypes.FETCH_ALL_LIVE_CHANNELS:
      return {
        ...state,
        liveChannelsList: payload,
      };

    case ActionTypes.UPDATE_LIVE_CHANNELS:
      return {
        ...state,
        liveChannelsList: state?.liveChannelsList?.map((channel) =>
          channel?.channelName === payload?.currentChannel?.channelName
            ? { ...channel, assigned: payload?.channelStatus }
            : channel
        ),
      };

    case ActionTypes.IP_CAMERA_VIDEO_STREAMING_STATUS:
      return {
        ...state,
        IPCameraVideoStreamingStatus: payload,
      };

    case ActionTypes.RESET_VIDEO_STREAMING_INFORMATION:
      return {
        ...initialState,
      };

    case ActionTypes.UPDATE_ACTIVE_IP_CAMERA_COUNT:
      return {
        ...state,
        IpCameraActiveCount:
          payload === "add"
            ? state?.IpCameraActiveCount + 1
            : state?.IpCameraActiveCount - 1,
      };

    case ActionTypes.IP_CAMERA_REQUEST_POPUP:
      return {
        ...state,
        allCameras: state?.allCameras?.map((camera) =>
          camera?.id === payload?.id
            ? { ...camera, open: payload?.requestPopupStatus }
            : camera
        ),
      };

    case ActionTypes.IP_CAMERA_PREVIEW_STATUS:
      return {
        ...state,
        allCameras: state?.allCameras?.map((camera) =>
          camera?.id === payload?.id
            ? {
                ...camera,
                start: payload?.previewStatus,
                previewUrl: payload?.previewUrl,
              }
            : camera
        ),
      };

    case ActionTypes.ALLOCATE_IP_CAMERA_ANGLE:
      return {
        ...state,
        allCameras: state?.allCameras?.map((camera) =>
          camera?.id === payload?.id
            ? { ...camera, allocatedAngle: payload?.angle }
            : camera
        ),
      };

    case ActionTypes.IP_CAMERA_ANGLE_LIST:
      return {
        ...state,
        IPCameraAngles: state?.IPCameraAngles?.map((camera) =>
          camera?.angleName === payload?.angle
            ? {
                ...camera,
                allocated: payload?.status,
              }
            : camera
        ),
      };

    default:
      return state;
  }
};
